<form [formGroup]="form" *ngIf="!loader">
    <div class="date_date_search">
        <mat-form-field>
            <mat-label class="text-white">From</mat-label>
            <input formControlName="startDate" matInput [matDatepicker]="picker1" (dateInput)="startDateChange($event)"
                (dateChange)="startDateChange($event)" placeholder="MM/DD/YYYY" />
            <mat-datepicker-toggle matIconSuffix [for]="picker1"></mat-datepicker-toggle>
            <mat-datepicker #picker1></mat-datepicker>
        </mat-form-field>
        <mat-form-field>
            <mat-label class="text-white">To</mat-label>
            <input formControlName="endDate" matInput [matDatepicker]="picker2" (dateInput)="endDateChange($event)"
                (dateChange)="endDateChange($event)" placeholder="MM/DD/YYYY" />
            <mat-datepicker-toggle matIconSuffix [for]="picker2"></mat-datepicker-toggle>
            <mat-datepicker #picker2></mat-datepicker>
        </mat-form-field>
        <c-button-group class="btn btn-sm btn-primary" role="group">
            <button cButton class="btn-primary" (click)="handleSearch()">Search</button>
            <button *ngIf="startDate !=='' ||  endDate !==''" cButton class="btn-primary"
                (click)="handleSearch('clear')">
                Clear
            </button>
        </c-button-group>
    </div>
</form>